export default __webpack_public_path__ + "static/media/best-price.d7c585b2.png";